import { useQuery } from "@tanstack/react-query";

import { medicationRequestQueriesStore } from "../api";

export const useAvailableRefillRequests = () => {
  return useQuery(
    medicationRequestQueriesStore.medicationRequest.list._ctx.available,
  );
};
